// extracted by mini-css-extract-plugin
export default {"joinControls":"JoinDebateControls_joinControls__er2hU"};